import { IconModule } from './../icon/icon.module';
import { NgModule } from "@angular/core";
import { StatusComponent } from "./status.component";
import { CommonModule } from "@angular/common";

@NgModule({
	declarations: [StatusComponent],
	imports: [CommonModule, IconModule],
	exports: [StatusComponent]
})
export class StatusModule {}
